/**
 * aBeauty 2026-08-19: widgetul WhatsApp propriu (snippets/abeauty-whatsapp.liquid).
 *
 * Face trei lucruri, nimic mai mult:
 *   1. deschide si inchide panoul cu clinici (<dialog>, deci top layer, focus
 *      trap si ESC gratuite de la browser);
 *   2. trimite un eveniment de lead catre yes.abeauty.ro cand vizitatorul alege
 *      o clinica, prin sendBeacon, care NU intarzie deschiderea WhatsApp;
 *   3. pe desktop deschide conversatia in tab nou, ca magazinul sa ramana.
 *
 * Ce se trimite: clinica, o cheie de idempotenta, calea paginii (fara query
 * string) si utm_source / utm_medium / utm_campaign, daca exista in URL.
 * Ce NU se trimite si nu se stocheaza: niciun cookie, nimic in localStorage sau
 * sessionStorage, niciun identificator de vizitator, niciun gclid sau fbclid.
 * De asta widgetul nu are nevoie de bifa de consimtamant.
 */
(function () {
  "use strict";

  var sheet = document.getElementById("abwa-sheet");
  var opener = document.querySelector("[data-abwa-open]");
  if (!sheet || !opener) return;

  var endpoint = sheet.getAttribute("data-abwa-endpoint");
  var mobile = window.matchMedia("(max-width: 749px)");
  var desktop = window.matchMedia("(hover: hover) and (pointer: fine)");

  // ── Deschidere / inchidere ────────────────────────────────────────────────

  function open() {
    if (sheet.open) return;
    // showModal exista peste tot din 2022; fara el, butonul ramane un no-op
    // vizibil, deci mai bine il ascundem decat sa para stricat.
    if (typeof sheet.showModal !== "function") {
      opener.hidden = true;
      return;
    }
    sheet.showModal();
    // Blocam scrollul din spate doar pe mobil: pe desktop, ascunderea barei de
    // scroll ar misca layoutul paginii sub panou.
    if (mobile.matches) document.documentElement.style.overflow = "hidden";
  }

  function close() {
    if (sheet.open) sheet.close();
  }

  opener.addEventListener("click", open);

  sheet.addEventListener("close", function () {
    document.documentElement.style.overflow = "";
    opener.focus();
  });

  // Click pe fundal (backdrop): tinta evenimentului e chiar dialogul.
  sheet.addEventListener("click", function (event) {
    if (event.target === sheet) close();
  });

  var closer = sheet.querySelector("[data-abwa-close]");
  if (closer) closer.addEventListener("click", close);

  // ── Evenimentul de lead ───────────────────────────────────────────────────

  // O cheie per (incarcare de pagina, clinica), tinuta doar in memorie. Cine
  // apasa de trei ori pe aceeasi clinica trimite aceeasi cheie, iar indexul unic
  // de pe server pastreaza un singur lead.
  var keys = Object.create(null);

  function clickKey(clinic) {
    if (!keys[clinic]) {
      keys[clinic] =
        window.crypto && typeof window.crypto.randomUUID === "function"
          ? window.crypto.randomUUID()
          : // Rezerva pentru browsere fara randomUUID: nu e un identificator de
            // persoana, doar o cheie de deduplicare pentru o singura pagina.
            "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
              var r = (Math.random() * 16) | 0;
              return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
            });
    }
    return keys[clinic];
  }

  function track(clinic) {
    if (!endpoint) return;

    var params = new URLSearchParams(window.location.search);
    var payload = {
      clickId: clickKey(clinic),
      channel: "whatsapp",
      clinic: clinic,
      path: window.location.pathname.slice(0, 256),
    };
    // Doar campania, niciodata un identificator de click (gclid, fbclid).
    var utm = { utmSource: "utm_source", utmMedium: "utm_medium", utmCampaign: "utm_campaign" };
    Object.keys(utm).forEach(function (key) {
      var value = params.get(utm[key]);
      if (value) payload[key] = value.slice(0, 100);
    });

    var body = JSON.stringify(payload);
    var sent = false;
    // text/plain e content-type safelisted CORS, deci nu exista preflight.
    if (navigator.sendBeacon) {
      try {
        sent = navigator.sendBeacon(endpoint, new Blob([body], { type: "text/plain;charset=UTF-8" }));
      } catch (e) {
        sent = false;
      }
    }
    if (!sent) {
      fetch(endpoint, {
        method: "POST",
        body: body,
        keepalive: true,
        mode: "cors",
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
      }).catch(function () {});
    }

    // Semnal local pentru GTM-ul care exista deja pe site. Daca se doreste o
    // conversie Google Ads pe el, se configureaza din GTM, sub Consent Mode.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "whatsapp_click", clinic: clinic });
  }

  sheet.addEventListener("click", function (event) {
    var link = event.target.closest ? event.target.closest("[data-abwa-clinic]") : null;
    if (!link) return;

    // Pe desktop lasam magazinul deschis. Pe mobil NU: iOS ar ramane cu o fila
    // goala dupa ce aplicatia WhatsApp preia linkul.
    if (desktop.matches) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener");
    }

    track(link.getAttribute("data-abwa-clinic"));
  });
})();
